export default "__VITE_ASSET__VX0ZhYS4__"